module.exports = __webpack_public_path__ + "static/media/landingvideo.deaecabf.mp4";